import React, { Component } from 'react';
import './Bookings.css';
import { connect } from 'react-redux';
import { bookings, bookingsFiltered, cancelBooking, setManualInvoiceId, delayBooking, assignNewDateToBooking } from '../../services/bookings';
import { getBookingGuests, queryDownloadInvoice, addTuristicTax } from '../../services/guests';
import Modal from '../Modal/Modal';
import { formatDate } from '../../utils/formatDate';
import { Select, DatePicker, DateRangePicker, Input, Icon, Button, Message, MessageBox, Checkbox, Dialog } from 'element-react';
import FileSaver from 'file-saver'
import Link from 'react-router-dom/Link';

class Bookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bookings: [],
      bookingId: '',
      idFilter: null,
      checkInDate: null,
      checkOutDate: null,
      options: [
        {
          value: '5ba2a714781811c4b2c4c60a',
          label: 'Pla del Grèvol'
        },
        {
          value: '5ba2a6e4781811c4b2c4c609',
          label: 'Quintanic'
        },
        {
          value: '5ba2a6b00dc419c4b22fa27c',
          label: 'Coll s`Espunya'
        },
        {
          value: '5ebfbcce3188813b7c0e0f34',
          label: 'Puigsaleres'
        },
        {
          value: '5e1cc2b102ff5f32acc48460',
          label: 'Del Noguer'
        },
        {
          value: '5e1cc2be02ff5f32acc48461',
          label: 'La Barraca'
        }
      ],
      value: '',
      appliedFilters: [],
      downloading: false,
      downloadingIndex: null,
      showModalInvoice: false,
      invoice: null,
      manualInvoiceBookingId: null,
      showManualInvoiceGenerator: false,
      assignDateBooking: null,
      showAssignDateCalendar: false,
      checkingNewDateAvailability: false,
      newBookingDate: null,
      newBookingRoomId: null
    };
  }

  async componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const bookingId = query.get('bookingId');

    if (bookingId) {
      this.idChange(bookingId);
    } else {
      this.loadBooking();
    }
  }

  async loadBooking() {
    const { data } = await bookings(0);
    this.setState({ bookings: data, loading: false });
  }

  showModal = () => {
    this.setState({ showModalInvoice: true });
  };

  hideModal = () => {
    this.setState({ showModalInvoice: false });
  };

  checkInDateSelect(date) {
    this.setState({ checkInDate: date });
    const ts = date ? parseInt(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : null;
    const filter = { label: 'checkInTimeStamp', value: ts };
    this.updateFilters(date ? filter : null);
  }

  checkOutDateSelect(date) {
    this.setState({ checkOutDate: date });
    const ts = date ? parseInt(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : null;
    const filter = { label: 'checkOutTimeStamp', value: ts };
    this.updateFilters(date ? filter : null);
  }

  filterById(id) {
    const filter = { label: 'roomId', value: id };
    this.updateFilters(filter);
  }

  idChange(id) {
    this.setState({ bookingId: id });
    const filter = { label: 'bookingId', value: id };
    this.updateFilters(filter);
  }

  async updateFilters(filter) {
    console.log('filter: ', filter);
    console.log('appliedFilters: ', this.state.appliedFilters);

    let filters = filter ? this.state.appliedFilters : [];

    if (filter) {
      const foundIndex = filters.findIndex(ele => ele.label === filter.label);
      if (foundIndex >= 0) {
        filters[foundIndex] = filter;
      } else {
        filters.push(filter);
      }
    }

    this.setState({ loading: true, appliedFilters: filters });

    const { data } = await bookingsFiltered([0, 2], filters);
    this.setState({ bookings: data, loading: false });
  }

  goToGuestData(bookingId) {
    this.props.history.push(`/guestdata`, bookingId);
  }

  goToAddExtras(bookingId) {
    this.props.history.push(`/extras`, bookingId);
  }

  showDeleteBookingDialog(bookingId) {
    MessageBox.confirm('Compte, estàs segur que vols eliminar aquesta reserva? No podràs veure mai més aquesta reserva.', 'Borrar reserva', {
      type: 'warning'
    }).then(async () => {
      try {
        await cancelBooking(bookingId);
        this.setState({ bookings: [...this.state.bookings.filter(booking => booking._id !== bookingId)] });
      } catch (err) {
        alert('Error');
      }
    }).catch(() => {
      alert('Error');
    });
  }

  delayBooking(id, bookingId, roomId) {
    MessageBox.confirm('Compte, estàs segur que vols aplaçar indefinidament aquesta reserva? Una altra persona podrà reservar ara mateix aquest dia.', 'Aplaçar reserva', {
      type: 'warning'
    }).then(async () => {
      try {
        await delayBooking(id, bookingId, roomId);
        this.setState({ bookings: [...this.state.bookings.map(booking => booking._id !== id ? booking : { ...booking, state: 4, hasDelayed: true })] });
      } catch (err) {
        alert('Error');
      }
    }).catch(() => { });
  }

  assignDate(booking) {
    this.setState({ assignDateBooking: booking, showAssignDateCalendar: true, newBookingRoomId: booking.roomId });
  }

  async changeBookingDate() {
    try {
      this.setState({ checkingNewDateAvailability: true });
      await assignNewDateToBooking(
        this.state.assignDateBooking.roomId,
        this.state.assignDateBooking.bookingId,
        [this.state.assignDateBooking.checkInDate, this.state.assignDateBooking.checkOutDate],
        [`${this.state.newBookingDate[0].getFullYear()}-${this.state.newBookingDate[0].getMonth()}-${this.state.newBookingDate[0].getDate()}`, `${this.state.newBookingDate[1].getFullYear()}-${this.state.newBookingDate[1].getMonth()}-${this.state.newBookingDate[1].getDate()}`],
        this.state.newBookingRoomId
      );

      // update booking UI
      this.setState({
        bookings: [...this.state.bookings.map(booking => booking._id !== this.state.assignDateBooking._id
          ? booking
          : {
            ...booking,
            roomId: this.state.newBookingRoomId,
            roomName: (this.state.options.find(room => room.value === this.state.newBookingRoomId)).label,
            state: booking.originalState,
            checkInDate: this.state.newBookingDate[0],
            checkOutDate: this.state.newBookingDate[1]
          }
        )]
      });

      // reset
      this.setState({ showAssignDateCalendar: false, checkingNewDateAvailability: false, assignDateBooking: null, newBookingDate: null });
    } catch (err) {
      this.setState({ checkingNewDateAvailability: false });
      console.error(err);
      alert('Fechas no disponibles');
    }
  }

  async downloadInvoice(index) {
    try {
      this.setState({ downloading: true, downloadingIndex: index });
      //const { data: { guests } } = await getBookingGuests(this.state.bookings[index]._id);

      if (/*guests && */this.state.bookings[index].invoiceId) {
        const response = await queryDownloadInvoice(this.state.bookings[index]._id);
        const file = new Blob([response.data], { type: 'application/pdf' });
        FileSaver.saveAs(file, `factura_${'A-' + ('000000' + this.state.bookings[index].invoiceId).slice(-6)}.pdf`);
        this.setState({ downloading: false });
      } else if (!this.state.bookings[index].invoiceId) {
        this.setState({ downloading: false });
        alert('Primero genera factura!');
      } else {
        alert('Introduce datos de huesped para facturar');
      }
    } catch (err) {
      console.error(err);
      this.setState({ downloading: false });
      alert('Se ha producido un error, refresca la pagina y vuelve a intentarlo.');
    }
  }

  async activateTuristicTax(index, event) {
    try {
      await addTuristicTax(this.state.bookings[index]._id, event);
    } catch (err) {
      alert('Error');
    }
  }

  generateInvoiceId = async (booking) => {
    this.setState({ showManualInvoiceGenerator: true, manualInvoiceBookingId: booking.bookingId });
  }

  renderFilters() {
    return (
      <div className="bookingsFilters">
        <div className="bookingsFilter">
          <p>Filtrar cabanya</p>
          <Select value={this.state.value} onChange={(val) => this.filterById(val)}>
            {
              this.state.options.map(el => {
                return <Select.Option key={el.value} label={el.label} value={el.value} />
              })
            }
          </Select>
        </div>
        <div className="bookingsFilter">
          <p>Check-in el dia:</p>
          <DatePicker
            firstDayOfWeek="1"
            format="dd-MM-yyyy"
            value={this.state.checkInDate}
            placeholder="Escoge dia"
            onChange={date => this.checkInDateSelect(date)}
          />
        </div>
        <div className="bookingsFilter">
          <p>Check-out el dia:</p>
          <DatePicker
            firstDayOfWeek="1"
            format="dd-MM-yyyy"
            value={this.state.checkOutDate}
            placeholder="Escoge dia"
            onChange={date => this.checkOutDateSelect(date)}
          />
        </div>
        <div className="bookingsFilter">
          <p>Identificador de reserva:</p>
          <Input placeholder="Escribir ..." value={this.state.bookingId} onChange={val => this.idChange(val)} />
        </div>
      </div>
    );
  }

  renderBooking() {
    return (
      <div className="bookingsList">
        {
          this.state.bookings.length > 0
            ? this.state.bookings.map((booking, index) => (
              <div key={index} className="bookingsItem" style={{ opacity: booking.state === 0 && booking.paid === false ? 0.5 : 1 }}>
                <div className="headerBooking">
                  <div>
                    {
                      booking.state === 0
                        ? <p style={{ color: '#03543f', backgroundColor: '#def7ec', borderRadius: '.25rem', padding: '5px', display: 'inline-flex', fontWeight: 500 }}>
                          {booking.state === 0 && booking.paid === false ? 'Pre - reserva web' : 'Reserva web'}
                        </p>
                        : booking.state === 4
                          ? <p style={{ color: '#42389d', backgroundColor: '#e5edff', borderRadius: '.25rem', padding: '5px', display: 'inline-flex', fontWeight: 500 }}>Reserva aplazada indefinidamente</p>
                          : <p style={{ color: '#ca8405', backgroundColor: '#ffe3cf', borderRadius: '.25rem', padding: '5px', display: 'inline-flex', fontWeight: 500 }}>Reserva manual</p>
                    }

                    {/* Special booking events */}
                    {booking.hasDelayed && booking.state !== 4 && <span><i className="el-icon-warning"></i> esta reserva ha sido movida de día</span>}
                    {booking.presentId && booking.state == 2 && <span><i className="el-icon-warning"></i> esta reserva ha sido canjeada por el regala #{booking.presentId}</span>}

                    {/* Invoice */}
                    <h4>Identificador de reserva: {booking.bookingId}</h4>
                    {!booking.presentId && <span>Identificador de factura: {
                      booking.invoiceId
                        ? 'A-' + ('000000' + booking.invoiceId).slice(-6)
                        : <button onClick={() => this.generateInvoiceId(booking)}>Sin id, generar manualmente</button>
                    }
                    </span>}

                  </div>
                  <h5>Reserva realizada: {formatDate(booking.createdAt)}</h5>
                </div>
                <div className="contentBookingsItem">
                  <div className="bookingItem">
                    <h5>Habitación: {booking.roomName}</h5>
                    <p>Check-in: {formatDate(booking.checkInDate)}</p>
                    <p>Check-out: {formatDate(booking.checkOutDate)}</p>

                    <p>Número adults: {booking.details.numAdults}</p>
                    <p>Número infants: {
                      booking.details.childsAges
                        ? booking.details.childsAges.map(age => `${age} anys`).join(', ')
                        : Array.isArray(booking.details.numChilds)
                          ? booking.details.numChilds.map(age => `${age} anys`).join(', ')
                          : `${booking.details.numChilds} (num total)`}
                    </p>
                  </div>
                  <div className="bookingItem">
                    <h5>Contacte</h5>
                    <p>Nom: {booking.details.info.name}</p>
                    <p>Telf: {booking.details.info.phone}</p>
                    <p>Email: {booking.details.info.email}</p>
                  </div>
                  <div className="bookingItem">
                    <h5>Extres</h5>
                    <p>Activitats: {booking.details.activities ? booking.details.activities : 'Sin actividades'}</p>
                    <p>Restaurant: {booking.details.restaurant ? booking.details.restaurant : 'Sin restaurante'}</p>
                    <p>Packs:
                        {
                        booking.details.packs && booking.details.packs.map((pack, index) => (
                          <span key={index}>{
                            pack === 'cava'
                              ? '· Ampolla de cava'
                              : pack === 'xocolat'
                                ? '· Chocolata'
                                : pack === 'kit'
                                  ? '· Kit de masatje'
                                  : null}
                          </span>
                        ))
                      }
                    </p>
                  </div>
                  <div className="bookingItem">
                    <h5>Pago</h5>
                    <p style={booking.paid === false ? { color: 'red' } : { color: 'green' }}>{booking.totalPaid} €</p>
                    {booking.paid === false && <p style={{ color: 'red' }}>NO PAGADO</p>}
                  </div>
                </div>
                <p style={{ marginLeft: 20 }}>Comentari del client: {booking.details.info.commentary}</p>

                <Checkbox checked={booking.turisticTax} onChange={(event) => this.activateTuristicTax(index, event)}>Añadir taxa turística</Checkbox>

                <div className="footerBookingItem">
                  <Button onClick={() => this.goToGuestData(booking._id)}>{booking.invoiceId ? 'Ver datos huéspedes' : 'Generar datos de factura'}</Button>
                  <Button onClick={() => this.goToAddExtras(booking._id)}>Modificar extras</Button>
                  {
                    this.state.downloading && this.state.downloadingIndex === index
                      ? <i className="el-icon-loading"></i>
                      : <i className="el-icon-document" onClick={() => this.downloadInvoice(index)}></i>
                  }
                  {(new Date() < new Date(booking.checkInDate)) && <i className="el-icon-delete" onClick={() => this.showDeleteBookingDialog(booking._id)}></i>}
                  {
                    ((booking.state === 0 && booking.paid) || booking.state === 2) && /*(new Date() < new Date(booking.checkInDate)) &&*/
                    <Button onClick={() => this.delayBooking(booking._id, booking.bookingId, booking.roomId)}>
                      <i className="el-icon-time"></i> Aplazar
                    </Button>
                  }
                  {booking.state === 4 && <Button onClick={() => this.assignDate(booking)}><i className="el-icon-time"></i> Asignar nueva fecha</Button>}
                </div>
              </div>
            ))
            : <p>No s'han trobat reserves.</p>
        }
      </div>
    );
  }

  dismissable = () => {
    this.setState({ showModalInvoice: false });
  }

  onIdChange = async (event) => {
    try {
      const newInvoiceValue = ('000000' + event.target.value).slice(-6);
      this.setState({ manualInvoiceId: newInvoiceValue });
    } catch (err) {
      alert('Error');
    }
  }

  generateInvoiceIdForBooking = async () => {
    try {
      await setManualInvoiceId(this.state.manualInvoiceBookingId, this.state.manualInvoiceId);
      const bookings = this.state.bookings.map((booking) => {
        if (booking.bookingId === this.state.manualInvoiceBookingId) {
          return {
            ...booking,
            invoiceId: this.state.manualInvoiceId
          }
        }

        return booking;
      });
      this.setState({ showManualInvoiceGenerator: false, bookings });
    } catch (err) {
      console.error(err);
    }
  }

  renderInvoiceIdGenerator = () => (
    <Dialog
      title={`Generar manualmente id de factura para booking: ${this.state.manualInvoiceBookingId}`}
      size="tiny"
      visible={this.state.showManualInvoiceGenerator}
      onCancel={() => this.setState({ showManualInvoiceGenerator: false })}
      lockScroll
    >
      <Dialog.Body>
        <label>
          <input
            type="number"
            name="name"
            value={this.state.manualInvoiceId}
            onInput={this.onIdChange}
          />
        </label>
        <span> -> A-{this.state.manualInvoiceId}</span>
        <h4 style={{ color: 'red' }}>IMPORTANTE: NO PODRÁS VOLVER A CAMBIARLO, TEN EN CUENTA EL NÚMERO ACTUAL DE LA ÚLTIMA FACTURA</h4>
      </Dialog.Body>
      <Dialog.Footer className="dialog-footer">
        <Button onClick={() => this.setState({ showManualInvoiceGenerator: false })}>Cancelar</Button>
        <Button type="primary" onClick={() => this.generateInvoiceIdForBooking()}>Confirmar</Button>
      </Dialog.Footer>
    </Dialog>
  );

  renderAssignDateCalendarModal = () => (
    <Dialog
      title={`Asignar nueva fecha de reserva para: ${(this.state.assignDateBooking || {}).bookingId}`}
      size="tiny"
      visible={this.state.showAssignDateCalendar}
      onCancel={() => this.setState({ showAssignDateCalendar: false, newBookingDate: null })}
      lockScroll
    >
      <Dialog.Body>
        {this.state.checkingNewDateAvailability
          ? <p><i className="el-icon-loading"></i> Checking availability</p>
          : <div>
            <DateRangePicker
              firstDayOfWeek="1"
              format="dd-MM-yyyy"
              value={this.state.newBookingDate}
              placeholder="Check in - check out"
              onChange={date => this.setState({ newBookingDate: date })}
              disabledDate={date => date < new Date()}
            />
            <Select placeholder="Nueva habitación..." value={this.state.newBookingRoomId} onChange={(val) => this.setState({ newBookingRoomId: val })}>
              {
                this.state.options.map(room => {
                  return <Select.Option key={room.value} label={room.label} value={room.value} />
                })
              }
            </Select>
          </div>
        }
      </Dialog.Body>
      <Dialog.Footer className="dialog-footer">
        <Button onClick={() => this.setState({ showAssignDateCalendar: false, newBookingDate: null })}>Cancelar</Button>
        <Button disabled={!this.state.newBookingDate} type="primary" onClick={() => this.changeBookingDate()}>Comprobar disponibilidad & confirmar</Button>
      </Dialog.Footer>
    </Dialog>
  )

  render() {
    return (
      <div className="bookingsViewWrapper">
        {this.renderFilters()}
        {this.renderAssignDateCalendarModal()}
        {this.renderInvoiceIdGenerator()}

        <h3>Reservas <span style={{ fontSize: 10 }}>(mostrando {this.state.bookings.length})</span></h3>
        <div className="subHeaderWrapper">
          <Link to="/settings">
            <button>CONFIGURACIÓ</button>
          </Link>
          <span style={{ marginLeft: '20px' }}></span>
          <Link to="/booking">
            <button>+ AFEGIR RESERVA</button>
          </Link>
        </div>
        {
          this.state.loading
            ? <Icon name={'loading'} style={{ padding: 8 }} />
            : this.renderBooking()
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({ rooms: state.rooms });

export default connect(mapStateToProps)(Bookings);



// WEBPACK FOOTER //
// ./src/components/Bookings/Bookings.js